/**
 * Turns an Edge Function failure into one sentence for the screen. supabase-js answers a non-2xx with the bare
 * "Edge Function returned a non-2xx status code" and keeps the response on `context`; the body carries what the
 * function actually said: a refusal `{ error: { code, message } }`, or the report wrapper's
 * `{ error: "Something went wrong…", reference: "E-…" }` for an unexpected failure, whose reference is what support
 * needs (2026-09-25: the Payments card swallowed it).
 */
export async function explainFunctionError(
  error: unknown,
  response: Response | null | undefined,
): Promise<Error> {
  try {
    const body = (await response?.json()) as
      { error?: { message?: string } | string; reference?: string } | undefined;
    if (typeof body?.error === "object" && typeof body.error.message === "string") {
      return new Error(body.error.message);
    }
    if (typeof body?.error === "string") {
      return new Error(
        typeof body.reference === "string"
          ? `${body.error} Reference ${body.reference}.`
          : body.error,
      );
    }
  } catch {
    // no JSON body
  }
  return error instanceof Error ? error : new Error("The connection failed.");
}

/** The response supabase-js attaches to a function error, if any. */
export function functionErrorResponse(error: unknown): Response | null {
  const context = (error as { context?: unknown } | null)?.context;
  return context instanceof Response ? context : null;
}
